module.exports = {
  TYPE_ID: {
    BANK: 1,
    BASIC_DEALER: 2,
    ORDER_AUTO_DEALER: 3,
  }
}
